import { render, staticRenderFns } from "./TickerHorizental.vue?vue&type=template&id=4c75b2d9"
import script from "./TickerHorizental.vue?vue&type=script&lang=js"
export * from "./TickerHorizental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports